// extracted by mini-css-extract-plugin
export default {"outlet":"next_outlet__jGyqx","title":"next_title__efika","workspace":"next_workspace__GUu74"};